export const DEFAULT_REVERIFY_VALVE = { mode: "off" };
const VALID_MODES = ["off", "auto", "targeted"];
/**
 * Returns the normalized valve or an error message. Pure; no throws.
 */
export function parseReverifyValve(input) {
    if (input === null || typeof input !== "object" || Array.isArray(input)) {
        return { ok: false, error: "reverifyValve must be an object" };
    }
    const obj = input;
    const mode = obj["mode"];
    if (typeof mode !== "string" || !VALID_MODES.includes(mode)) {
        return {
            ok: false,
            error: `mode must be one of: ${VALID_MODES.join(", ")}`,
        };
    }
    const validMode = mode;
    if (validMode === "off") {
        // Normalize: drop all extra fields
        return { ok: true, value: { mode: "off" } };
    }
    if (validMode === "auto") {
        const sampleEveryN = obj["sampleEveryN"];
        if (typeof sampleEveryN !== "number" ||
            !Number.isInteger(sampleEveryN) ||
            sampleEveryN < 1) {
            return {
                ok: false,
                error: "sampleEveryN must be a positive integer when mode is 'auto'",
            };
        }
        return { ok: true, value: { mode: "auto", sampleEveryN } };
    }
    // mode === 'targeted'
    const targetedFields = obj["targetedFields"];
    if (!Array.isArray(targetedFields) ||
        !targetedFields.every((f) => typeof f === "string")) {
        return {
            ok: false,
            error: "targetedFields must be a string[] when mode is 'targeted'",
        };
    }
    const rawUntil = obj["targetedUntil"];
    let targetedUntil;
    if (rawUntil === undefined || rawUntil === null) {
        targetedUntil = rawUntil;
    }
    else if (typeof rawUntil === "string") {
        targetedUntil = rawUntil;
    }
    else {
        return { ok: false, error: "targetedUntil must be an ISO string or null" };
    }
    const valve = {
        mode: "targeted",
        targetedFields: targetedFields,
    };
    if (targetedUntil !== undefined) {
        valve.targetedUntil = targetedUntil;
    }
    return { ok: true, value: valve };
}
//# sourceMappingURL=reverify-valve.js.map